import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileUtilsService } from 'src/app/core/services/file-utils.service';
import { FileAttachment } from '@models/shared';

@Component({
    selector: 'app-files-attachment',
    template: `
    <div style="padding: 16px; ">
      <mat-chip-set class="custom-chip-list">
        @for (file of files; track file; let i = $index) {
          <mat-chip
            class="custom-chip"
            (click)="openPdfInBrowser(file)"
            [removable]="!readOnly"
            [matTooltip]="file.originalFileName"
            (removed)="removeFile(i)"
            style="margin: 4px; cursor: pointer;"
            >
            <span>{{ file.fileName }} </span>
            @if (!readOnly) {
              <button matChipRemove aria-label="Supprimer la pièce jointe">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-chip>
        }
      </mat-chip-set>
    </div>
    `,
    styles: [
        `
      :host {
        display: block;
      }

      .custom-chip-list {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
      }

      .custom-chip {
        --mat-chip-container-height: 32px;
        padding: 0 8px;
        border-radius: 16px;
      }
    `
    ],
    imports: [MatChipsModule, MatIconModule, MatButtonModule, MatTooltipModule]
})
export class FilesAttachmentComponent {
  @Input() files: FileAttachment[] = [];
  @Input() readOnly = false;
  @Output() fileRemoveEmit = new EventEmitter<FileAttachment[]>();

  constructor(private readonly fileUtils: FileUtilsService) {}

  downloadFile(file: FileAttachment): void {
    if (file.blobattachment) {
      this.fileUtils.downloadBlob(file.blobattachment, file.originalFileName);
    }
  }

  downloadAllFiles(): void {
    if (this.files && this.files.length > 0) {
      this.files.forEach((file) => {
        if (file.blobattachment) {
          this.fileUtils.downloadBlob(file.blobattachment, file.originalFileName);
        }
      });
    }
  }

  openPdfInBrowser(file: FileAttachment): void {
    if (file.blobattachment && file.originalFileName.endsWith('.pdf')) {
      const blob = new Blob([file.blobattachment], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    }
  }

  removeFile(index: number) {
    if (this.readOnly) {
      return;
    }
    const fichierASuppr = this.files.splice(index, 1);
    this.fileRemoveEmit.emit(fichierASuppr);
  }
}
